import React, { PropsWithChildren } from 'react';
import SideNav from 'shared/components/navigation/sidenav';
import TopHeader from 'shared/components/navigation/topHeader';

const Layout: React.FC<PropsWithChildren> = (props) => {
	return (
		<div id='wrapper'>
			<SideNav />
			<div id='page-wrapper' className='gray-bg'>
				<div className='page-container'>
					<TopHeader />
					{props.children}
				</div>
			</div>
		</div>
	);
};

export default Layout;
